'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/3/6.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _characteristicRegional = require('redux/modules/characteristicRegional');

var characteristicRegional = _interopRequireWildcard(_characteristicRegional);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CharacteristicRegional = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch(characteristicRegional.load()));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.characteristicRegional.data
  };
}, (0, _extends3.default)({}, characteristicRegional)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CharacteristicRegional, _Component);

  function CharacteristicRegional() {
    (0, _classCallCheck3.default)(this, CharacteristicRegional);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CharacteristicRegional).call(this));

    _this.state = {
      isContentScorllShow: false,
      contentDatas: [{
        url: '/characteristicregionalstore',
        id: '02',
        imgUrl: 'http://tupian.goeasy.cn:9999/yipinwang/header/img2.png'
      }, {
        url: 'http://vr.craftschina.cn:8080/pageBox/zhengzhou_index.html',
        id: '03',
        imgUrl: 'http://tupian.goeasy.cn:9999/yipinwang/tsqy/zzgwc.jpg'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(CharacteristicRegional, [{
    key: 'onBtnClickHandler',
    value: function onBtnClickHandler() {
      this.setState({
        isContentScorllShow: !this.state.isContentScorllShow
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CharacteristicRegional.scss');
      var _state = this.state;
      var isContentScorllShow = _state.isContentScorllShow;
      var contentDatas = _state.contentDatas;
      // const {data} = this.props;

      var headerArray = [{
        text: '全部',
        value: 'ALL'
      }, {
        text: '特色区域',
        value: 'TSQY'
      }, {
        text: '特色工厂',
        value: 'TSGC'
      }];

      return _react2.default.createElement(
        'div',
        { className: styles.cr_component },
        _react2.default.createElement('img', { className: styles.comImg, src: 'http://tupian.goeasy.cn:9999/yipinwang/header/bg_img1.jpg' }),
        _react2.default.createElement(_components.NewHeader, null),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.contentLeft, style: { background: 'rgba(0,0,0,0.2)' } },
            contentDatas ? _react2.default.createElement(_components.GoeasyCarouselTsqy, { url: '/characteristicregionalstore/', isArrow: !!0, datas: contentDatas }) : '',
            isContentScorllShow && contentDatas ? _react2.default.createElement(_components.NewTsqySearchPageComponent, { headerArray: headerArray }) : ''
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentRight },
            _react2.default.createElement('div', { className: styles.contentRightBlack }),
            _react2.default.createElement('img', { onClick: this.onBtnClickHandler.bind(this),
              src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-off.png', alt: '',
              className: styles.contentImg + ' ' + (isContentScorllShow ? '' : styles.contentMiss) }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/', className: styles.contentRightHome },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-home.png', alt: '' })
            )
          )
        )
      );
    }
  }]);
  return CharacteristicRegional;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = CharacteristicRegional;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/CharacteristicRegional/CharacteristicRegional.js
 ** module id = 1449
 ** module chunks = 0
 **/